module.exports = __webpack_public_path__ + "img/icon-room-family-room.f3889da9.svg";